import isEmpty from 'lodash/isEmpty';
import { browserName, getUA, osName } from 'react-device-detect';
import Communication from './Communication';
import Session from './Session';

class Logger {
	static previousActions = [];

	static async logToServer(data, isError) {
		const { accountInfo, settings, preferences } = Session.getData();
		const { customerDetails = {} } = accountInfo;
		let logData = { ...data };
		let stringLogData = '';

		// accountInfo info
		if (!isEmpty(accountInfo)) {
			logData.CustomerID = accountInfo.customerId;
			logData.CorpID = accountInfo.corporationId;
			logData.UserID = accountInfo.userId;
			logData.Username = customerDetails.username;
			logData.RateSetType = Session.getRateSetType();
			logData.isSAS = accountInfo.accountId
				? accountInfo.accountId !== 0
				: false;
		}

		// settings
		if (!isEmpty(settings)) {
			logData.buildVersion = settings.BuildVersion;
			logData.page = settings.Page;
		}

		// preferences
		if (!isEmpty(preferences)) {
			logData.HasUpgradedToShipStation =
				preferences.HasUpgradedToShipStation === '1';
		}

		// environment
		logData.browserInfo = getUA;
		logData.device = osName;
		logData.browser = browserName;

		// TO DO: Need to log boolean value for state of SDC Connect plugin when thats ready
		// this.logData['connectAppReady'] = PluginInterface.status === 'available' && PluginInterface.deviceEngine.className == 'NawsEngine';

		if (isError) {
			logData.previousActions = this.getAllActionData();
		}

		logData = Logger.replaceFieldData(logData);

		// convert JSON to string and replace colons with "=" for easier splunk searching
		stringLogData = JSON.stringify(logData);

		// remove quotes from properties
		stringLogData.replace(/\\"/g, '\uFFFF'); // TODO: revisit here as this line is not doing anything
		// eslint-disable-next-line no-useless-escape
		stringLogData = stringLogData
			.replace(/"([^"]+)":/g, '$1:')
			.replace(/\uFFFF/g, '\\"');

		// replace colons with equals signs
		stringLogData = stringLogData.replace(/:\s*/g, '=');

		await Communication.postLogs(stringLogData);
	}

	static replaceFieldData(data) {
		Object.entries(data).forEach(([key, value]) => {
			if (typeof value === 'string') {
				const newKey = key.toLowerCase();

				if (newKey.indexOf('password') !== -1) {
					data[key] = '--removed--';
				}

				// replace double quotes with single quotes in json values
				value.replace(/"/g, "'");

				// replace all '=' with hyphen in json values
				value.replace(/=/g, '-');
			}

			if (value & (typeof value === 'object')) {
				this.replaceFieldData(value);
			}
		});

		return data;
	}

	static saveActionData(event, actionInfo) {
		const date = new Date(),
			timestamp = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`,
			action = { event, time: timestamp };

		if (actionInfo) {
			action.data = actionInfo;
		}

		if (this.previousActions.length === 10) {
			this.previousActions.shift();
		}

		this.previousActions.push(action);
	}

	static getAllActionData() {
		return this.previousActions;
	}
}

export default Logger;
